import { z } from 'zod';

export const createBranchSchema = z.object({
  name: z.string().trim().min(1, '事業所名を入力してください。'),
  code: z
    .string()
    .trim()
    .min(1, '事業所コードを入力してください。')
    .regex(/^[a-zA-Z0-9]+$/, '英数字のみ使用可能です。'),
});

export type CreateBranchFormFieldValues = z.infer<typeof createBranchSchema>;
